import { z } from "zod";

export const getVehiclesDetailsByUuidsRequest = z.object({
  uuids: z.array(z.uuid()),
});

export type GetVehiclesDetailsByUuidsRequest = z.infer<
  typeof getVehiclesDetailsByUuidsRequest
>;
